import { createSlice } from "@reduxjs/toolkit";

import { fetchTopOpportunitiesByBestFit } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load top opportunities by best fit";

const topOpportunitiesByBestFitSlice = createSlice({
  name: "topOpportunitiesByBestFit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTopOpportunitiesByBestFit.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTopOpportunitiesByBestFit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchTopOpportunitiesByBestFit.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default topOpportunitiesByBestFitSlice.reducer;
